import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RESONANCE_VISIONS } from '../constants';

const useResonanceVisionOptions = () => {
  const { t } = useTranslation('projects');

  return useMemo(
    () => [
      {
        label: t('default'),
        value: RESONANCE_VISIONS.DEFAULT,
      },
      {
        label: t('topExtraCorrelation'),
        value: RESONANCE_VISIONS.TOP_EXTRA_CORRELATION,
      },
      {
        label: 'Uniqa',
        value: 'UNIQA',
      },
    ],
    [t],
  );
};

export default useResonanceVisionOptions;
